<template>
  <div class="home">
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary" align-center>
              <v-toolbar-title>🐶 EmojiCode 🐶</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-title @click="emojiSelf">😻🏯🥙🛐✉️🐲</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
          >
            {{ snackbar_text }}

            <template v-slot:action="{ attrs }">
              <v-btn
                color="blue"
                text
                v-bind="attrs"
                @click="snackbar = false"
              >
                Close
              </v-btn>
            </template>
          </v-snackbar>
              <v-form>
                <div >
                  <v-text-field
                    outlined
                          v-model="inText"
                          label="Paste Your Text"
                          v-mask="textMask"
                          hint="Only letters, numbers, spaces, and dash/underscore characters."
                          persistent-hint
                          class='mb-2'
                          @focus="$event.target.select()"
                        ></v-text-field>

                  <v-textarea
                    outlined
                    readonly
                    name="input-7-4"
                    label="EmojiCode (Tap to copy)"
                    :value="toEmoji"
                    @click="copyEmojiCode"
                    v-touch:tap="copyEmojiCode"
                  ></v-textarea>
                </div>
                <div class='mb-8'>
                <v-divider></v-divider>
                </div>
                <div>
                  <v-text-field
                    outlined
                    v-model="inEmoji"
                    label="Paste Your EmojiCode"
                    hint="Only emoji generated from EmojiCode."
                    :rules="[emojiMask]"
                    persistent-hint
                    class='mb-2'
                    @focus="$event.target.select()"
                  ></v-text-field>
                  <v-textarea
                    outlined
                    readonly
                    name="input-7-4"
                    label="Text (Tap to copy)"
                    :value="toYt"
                    @click="copyTextCode"
                    v-touch:tap="copyTextCode"
                  ></v-textarea>
                </div>
              </v-form>
            </v-card-text>
            <v-card-actions>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
// import Player from '@/components/Player.vue'
// const emojiRegex = require('emoji-regex/text.js')
const emojiRegex = require('emoji-regex/RGI_Emoji.js')
const { indexOf } = require('stringz')
const bigInt = require('big-integer')

export function ytMaskRegex (value) {
  // const hours = [
  //   /[0-2]/,
  //   value.charAt(0) === '2' ? /[0-3]/ : /[0-9]/
  // ]
  // const minutes = [/[0-5]/, /[0-9]/]
  // return value.length > 2 // if
  //   ? [...hours, ':', ...minutes] // then
  //   : hours // else

  const pat = /[0-9 A-Za-z_-]/
  const ytValid = new Array(1000).fill(pat)
  return ytValid
}

export default {
  name: 'Home',
  data () {
    return {
      inText: '',
      inEmoji: '',
      textMask: ytMaskRegex,
      timeout: 2000,
      snackbar: false,
      snackbar_text: 'Copied to clipboard!',
      emojiMask: value => {
        const pattern = /[0-9 A-Za-z_-]/
        return !pattern.test(value) || 'Invalid EmojiCode'
      },
      youtube_ascii_list: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_0123456789 ',
      emoji_list: ['✡️', '🚤', '😻', '🍛', '🚬', '🇼🇸', '🥒', '🇻🇬', '🇵🇼', '🌆', '💴', '💽', '😿', '🔷', '📑', '🔓', '💧', '🌃', '👊', '🇳🇨', '🇻🇮', '🇵🇷', '🎲', '💷', '🏯', '👖', '🤣', '🏤', '🍠', '🤏', '🦨', '✍️', '🇪🇹', '♠️', '🇨🇦', '🔟', '🦪', '😛', '💵', '🚴', '😾', '🇸🇱', '👕', '🙊', '🎁', '🇸🇽', '🌰', '🛑', '🙋', '☘️', '❎', '💩', '🚜', '🛺', '🇸🇻', '🇵🇾', '🐜', '🤲', '🦜', '🤳', '🍩', '🧏', '🇬🇼', '◼️', '🇨🇨', '🧿', '🔐', '♣️', '🔻', '🌼', 'ℹ️', '🇰🇵', '😸', '🚰', '🧉', '🧽', '🟧', '👲', '🏃', '🦑', '🟢', '👝', '👛', '🚾', '🃏', '🎅', '🚂', '👎', '🤚', '🍷', '🇱🇻', '🇦🇴', '🚀', '🖤', '❔', '🚋', '🧝', '🌏', '🍶', '🧥', '🙎', '🇪🇪', '😅', '👂', '🇮🇱', '🔰', '🏁', '🈲', '🥅', '5️⃣', '⏰', '🐮', '🈁', '🚵', '🍪', '📶', '📀', '😹', '🚸', '🆘', '🐪', '🎶', '🇷🇼', '😣', '🏅', '🍮', '🎽', '🎮', '💠', '🟡', '🔏', '🙏', '💜', '🇲🇦', '🔞', '🍸', '🇩🇪', '🚶', '🇬🇪', '➿', '🐌', '❣️', '🍄', '🇸🇴', '🥏', '🥡', '🩰', '🍍', '🚄', '🤍', '🧮', '🥣', '😑', '🤝', '👏', '🧡', '🙅', '🦄', '🇬🇺', '🇺🇾', '1️⃣', '🇪🇬', '🟩', '🧯', '🤥', '💳', '🇮🇨', '🩳', '🚲', '🧨', '🛬', '🇧🇴', '🧓', '🎐', '🇹🇷', '6️⃣', '🧑', '🇲🇰', '↙️', '🇰🇬', '🇬🇮', '🇮🇸', '🐾', '🇲🇳', '📳', '🇹🇰', '🚺', '📫', '🇸🇲', '🇼🇫', '♦️', '💀', '🦢', '🇧🇾', '🧊', '🧸', '👐', '🇸🇰', '💃', '👪', '㊗️', '🦀', '🛫', '🇨🇷', '🌙', '💒', '😶', '⬆️', '💔', '🕚', '🔩', '👤', '🦧', '🪂', '📡', '🍊', '🇨🇬', '😚', '👗', '🦂', '🟥', '🥵', '🏦', '🎆', '📪', '🇪🇸', '🦐', '™️', '🇳🇪', '🎯', '🎿', '🇳🇷', '🇫🇮', '🔽', '👷', '🇫🇷', '🍻', '🇱🇺', '🧶', '😎', '👵', '↪️', '🇲🇬', '🇬🇾', '🇱🇦', '🗼', '🆗', '🐠', '〰️', '🕧', '🪐', '👀', '🪓', '🐘', '📿', '☹️', '🇯🇲', '🥾', '🌱', '🇧🇫', '⏳', '🦝', '🇲🇨', '💈', '🔙', '🚖', '🇨🇰', '🍖', '🔇', '🉐', '🌹', '🇧🇭', '⤴️', '🍑', '💤', '❓', '📁', '✏️', '🐆', '💱', '🥝', '🥨', '😍', '🌅', '👱', '🏠', '🧔', '🎍', '🤑', '🧺', '🧪', '🥛', '🥯', '📮', '🦔', '💲', '🌛', '🦴', '💮', '🇰🇳', '🦸', '🍓', '👧', '🕞', '🇹🇲', '🍬', '🍙', '⚜️', '🇸🇪', '💾', '🔝', '🇦🇿', '🛴', '💰', '*️⃣', '🆓', '🍈', '🧈', '🍭', '🇦🇽', '🧂', '🙀', '🇨🇭', '🙉', '😗', '🇩🇲', '🇲🇲', '🇻🇨', '🥌', '🌽', '😲', '🙃', '🕍', '💄', '🚒', '🔁', '🐉', '📭', '💣', '🐰', '🕙', '🎸', '😦', '🐩', '🇱🇧', '👳', '🍱', '🍚', '🇬🇳', '👢', '🇨🇻', '🔡', '💌', '⛹️', '🍫', '↕️', '🇦🇹', '🇬🇫', '📓', '🔒', '🥪', '📜', '🔛', '🎭', '☸️', '🇲🇩', '🇧🇦', '🐀', '🇸🇮', '🆕', '🇻🇦', '🌘', '🔴', '🌳', '🙌', '🌝', '📂', '🚷', '🌀', '🐐', '🕑', '🅿️', '🩺', '🔚', '🍗', '🔘', '🔋', '🛀', '🏡', '😓', '👫', '🧜', '🐴', '💙', '🦎', '☝️', '🐍', '📋', '✳️', '🇬🇦', '🐯', '🥟', '🇬🇧', '🚈', '🇳🇬', '🇷🇺', '😳', '🔸', '🇯🇪', '🥖', '🇸🇸', '🇦🇺', '🐃', '🇧🇧', '😯', '🌾', '🚠', '🗽', '🤛', '🦦', '🟣', '☺️', '🚦', '👃', '🍧', '🧣', '🔖', '👥', '👮', '🈹', '◀️', '🇯🇴', '🇾🇹', '😋', '🇸🇭', '🚟', '🚼', '🏧', '😕', '🤿', '🇸🇷', '↔️', '🇲🇸', '⚗️', '👔', '🔱', '🚯', '🧍', '😥', '🥴', '👄', '🧵', '💼', '🈂️', '🎹', '🇿🇼', '🇪🇨', '👾', '🙈', '🎷', '👍', '🔆', '☂️', '🐇', '🌋', '🧫', '🌚', '🚝', '🤟', '🚐', '💍', '😠', '🦯', '💋', '🧄', '🦉', '®️', '💏', '😃', '🐕', '🧗', '🧹', '🔜', '🇳🇿', '🍿', '🇧🇲', '🕥', '🇷🇸', '🚧', '📬', '🎏', '🅰️', '🐅', '📅', '📱', '👑', '🧀', '🐹', '🚕', '♥️', '💭', '🇱🇸', '💓', '🕛', '🕟', '🧃', '🦇', '💡', '🇳🇺', '🔠', '🇲🇶', '⚛️', '🍎', '🏨', '🚍', '👚', '🎡', '📗', '🧧', '⏫', '💨', '🍒', '🥂', '👰', '👋', '😜', '🇻🇪', '😺', '📣', '🎰', '🧰', '✂️', '🇹🇯', '🌟', '📰', '😵', '🌴', '📛', '👟', '🧤', '🍌', '🦋', '🕗', '🐢', '🥧', '🎎', '🍺', '💚', '🔵', '🎻', '🇧🇪', '🍂', '🏴', '🇮🇷', '🇬🇷', '🇹🇭', '#️⃣', '📎', '🌜', '🦍', '📢', '🍘', '🇨🇿', '🇸🇾', '🥬', '🏐', '⚖️', '🥀', '🌷', '🔫', '🐶', '🇰🇾', '😰', '🛌', '🎴', '👶', '🇻🇳', '📺', '🇲🇱', '🇭🇹', '🔌', '🌁', '🎤', '🤙', '🇫🇰', '🎃', '🥐', '🦖', '🌲', '🇬🇬', '🍁', '🌕', '🐛', '👺', '😌', '🇰🇼', '👅', '🧴', '📲', '🍼', '🔄', '🐋', '🍉', '🇬🇶', '📼', '☄️', '🥘', '💫', '🍐', '🤓', '🇪🇺', '⬇️', '🚥', '🇧🇸', '🆖', '🔀', '🇬🇵', '🚱', '📘', '🎓', '🇵🇫', '🏉', '🥍', '🤽', '🤩', '🚔', '🐺', '🌞', '🚁', '🌇', '🇸🇦', '🎣', '📹', '🔪', '🚩', '😖', '💹', '💆', '🥦', '👒', '🇭🇳', '🥮', '😬', '😡', '🤡', '🧒', '🪒', '💉', '😧', '🚫', '🤷', '💖', '🔧', '🚻', '🚗', '🤐', '👻', '🙁', '📧', '☣️', '📒', '😩', '⏏️', '😘', '🕜', '🌑', '🇹🇴', '🦊', '🟫', '☀️', '🐧', '🤫', '🤰', '🇵🇬', '🚊', '🏭', '🟨', '🥢', '😄', '🇬🇲', '🥞', '☁️', '🥄', '🇷🇴', '🇱🇨', '2️⃣', '🔉', '🇹🇳', '📩', '⁉️', '🦟', '🇨🇩', '😱', '🐒', '📤', '🏳️', '📴', '✒️', '🇿🇲', '📸', '🔥', '🇲🇺', '🇲🇭', '🔂', '🅾️', '🐲', '🌺', '🌻', '🩲', '🏬', '🇷🇪', '🚙', '🎀', '🇳🇦', '🙍', '🤮', '🤨', '🔕', '🙄', '‼️', '🇲🇷', '🐨', '🥽', '🐚', '🎺', '🔈', '🎈', '🇨🇲', '💸', '🇹🇫', '📌', '🧾', '🦾', '🤸', '👈', '😝', '🇹🇻', '🤦', '🤪', '🥑', '😨', '🙂', '👇', '🦩', '🐂', '↩️', '😮', '🍹', '🇲🇹', '😆', '🚨', '🇵🇦', '🤱', '📙', '🐵', '🐈', '🛷', '🇴🇲', '📵', '♨️', '🕖', '🦶', '🥔', '🥓', '🍨', '◻️', '👸', '📕', '🔗', '▪️', '🇵🇲', '🈷️', '🇸🇩', '🇹🇨', '🦙', '🐽', '🇬🇹', '🇫🇯', '🇲🇴', '🌌', '🟪', '💪', '🚇', '🤯', '🛹', '🗾', '✅', '🖕', '🥊', '🔯', '🎢', '🇮🇳', '🎒', '🛕', '☢️', '✊', '🇦🇫', '☠️', '🇪🇭', '💦', '🥼', '🏊', '3️⃣', '🤬', '🥇', '😭', '🏈', '🚮', '🏣', '😙', '➗', '📔', '🎦', '🚽', '💞', 'Ⓜ️', '🕎', '©️', '🎂', '🚭', '🍣', '🦵', '✈️', '🐟', '📚', '🔼', '😉', '🏩', '✝️', '📉', '👬', '🍝', '🙆', '↘️', '🚛', '🥶', '💿', '🚃', '🐝', '🇲🇼', '🆑', '🍜', '🕝', '✨', '⤵️', '🇬🇱', '✉️', '🍴', '⚱️', '🐔', '🥱', '🔊', '🛂', '🦗', '🩱', '🧁', '💇', '🐸', '🟤', '🤞', '🇦🇼', '🇨🇴', '🇰🇷', '🍾', '🛶', '🛃', '🚚', '🚪', '🏂', '🇨🇱', '🧠', '🇮🇩', '🇾🇪', '😇', '😏', '🇬🇩', '🎊', '🇨🇫', '😴', '🌮', '↗️', '🧎', '🇨🇽', '🇸🇨', '🥕', '➕', '🐡', '🧳', '🐻', '🇮🇲', '🐙', '🆎', '🎋', '👠', '🚘', '🥺', '🌓', '🇮🇪', '🕡', '🎳', '❕', '📍', '🌯', '🐣', '💥', '🐑', '📝', '🉑', '🌿', '📨', '🏀', '🔹', '🏇', '🇧🇼', '🍤', '🇵🇳', '🧟', '💝', '🌵', '🙇', '⏪', '🥰', '🧚', '🦒', '🍇', '🎇', '🟦', '🔶', '🥠', '🤗', '🤧', '▫️', '🇸🇬', '🍦', '📻', '😈', '🆚', '🤾', '👡', '🚞', '💎', '🖖', '🐷', '😫', '🦅', '🎪', '🔣', '🇨🇮', '👭', '🍅', '💁', '😼', '🚹', '🦏', '🤴', '📥', '🔢', '🍃', '💛', '😷', '🕔', '🇰🇿', '🏸', '🇲🇪', '🇦🇶', '🕓', '📈', '🛅', '🎬', '🍞', '🎨', '🈳', '🇮🇹', '🚓', '🧞', '🕋', '💗', '👹', '🚌', '🚑', '🤜', '🍆', '👼', '☑️', '🩸', '🤼', '⌨️', '↖️', '❄️', '🔦', '🇦🇸', '🥜', '🎧', '🕺', '🌒', '📄', '🇫🇲', '🇱🇹', '🏋️', '🎩', '😟', '㊙️', '🇧🇩', '➖', '🎉', '🦞', '🦷', '🦚', '😒', '☃️', '⚙️', '🇹🇱', '🛸', '🎱', '🎌', '🤔', '👉', '🎑', '💂', '🎥', '🕢', '💯', '🇲🇻', '🍋', '🔔', '🥁', '🔍', '🥫', '🌖', '🇹🇼', '🌍', '📐', '🦁', '😔', '🌸', '🐥', '🤵', '🍔', '8️⃣', '🇳🇱', '🆔', '🇻🇺', '🛄', '🧩', '📖', '🇹🇹', '🦆', '🇧🇯', '♻️', '🇱🇷', '🈶', '🔳', '👩', '🛵', '🐗', '😤', '🔅', '✋', '🌐', '🤶', '👿', '4️⃣', '👦', '🔬', '🕕', '🇭🇰', '🇭🇺', '🤠', '🥳', '🇯🇵', '🇲🇿', '🧲', '🧦', '✴️', '🥗', '🈵', '🐖', '🌔', '⬅️', '🈴', '🔤', '🇺🇸', '🇲🇽', '🌎', '😊', '👨', '🌊', '🧱', '🇱🇾', '⚠️', '🕒', '🇲🇵', '🧢', '👙', '🇩🇯', '🇱🇮', '🥤', '☎️', '👌', '🍟', '🧆', '🦕', '🕤', '🐤', '🏄', '🕐', '🇵🇹', '☯️', '🔺', '🦿', '🇦🇩', '🚅', '🎼', '🔃', '🇽🇰', '🛐', '🏺', '🇦🇷', '🐄', '🥋', '🥻', '🇧🇷', '👽', '🏢', '🌉', '🏓', '⏬', '🇲🇾', '☪️', '🇨🇺', '😁', '😽', '😞', '💢', '🇺🇦', '🍢', '🇵🇭', '🏆', '🚉', '🐊', '🛒', '🏰', '🧭', '🌭', '⚰️', '🇧🇬', '🇿🇦', '🦮', '🟠', '🧙', '🇶🇦', '🇹🇿', '🦛', '🇳🇫', '💕', '🧖', '🪁', '🏪', '🔨', '🔭', '🪑', '🇺🇳', '🇨🇼', '🩹', '🦡', '📦', '🚆', '🇦🇬', '🇧🇱', '🇰🇮', '💑', '🎾', '😀', '❇️', '🤢', '🧐', '🧅', '🪔', '🏫', '🏮', '🚏', '😪', '🐫', '☦️', '✖️', '🐞', '🇰🇪', '🦈', '🔎', '🇹🇩', '🕦', '🇸🇿', '🥙', '🌂', '🐼', '🇭🇷', '🤖', '🧬', '🇩🇴', '🇦🇱', '📏', '🎠', '🥎', '🇧🇳', '🈸', '🤭', '❤️', '🦻', '😐', '🚡', '🧷', '🍀', '🇳🇮', '🦌', '💟', '🏹', '🥉', '👞', '🥭', '💅', '🕣', '📷', '🇫🇴', '💘', '🐭', '🦹', '🍰', '🇳🇵', '🇧🇮', '➰', '💺', '🐱', '🏏', '🇰🇭', '🧛', '👆', '🥈', '🦃', '7️⃣', '〽️', '👘', '🇵🇰', '🤺', '🇹🇬', '🇦🇮', '🔮', '🇪🇷', '📟', '🏌️', '🇺🇬', '🇧🇿', '🇧🇶', '🏑', '👜', '🛁', '☮️', '🍯', '💶', '🔑', '🥚', '➡️', '🏥', '🪀', '❌', '🍵', '🦥', '🍳', '🇦🇪', '🥥', '📊', '⏩', '🚎', '👯', '🇵🇱', '🇱🇰', '🕘', '🇮🇶', '🌗', '🧻', '🕠', '0️⃣', '🇩🇰', '🤹', '👴', '🍲', '🕌', '📞', '🦺', '📆', '💻', '🇦🇲', '👓', '🚢', '🧼', '🇸🇳', '🐳', '🚳', '🇨🇾', '📯', '📃', '🦓', '🇸🇧', '🦽', '🐓', '🍏', '🏒', '🦠', '🗿', '⚔️', '🍥', '🅱️', '🧕', '🎫', '🎄', '😢', '9️⃣', '🍕', '🇵🇸', '🇧🇹', '🐏', '🚿', '🥩', '🌄', '🐬', '👣', '🇬🇭', '💐', '🇺🇿', '🌠', '⛎', '🇳🇴', '🤕', '🤘', '✌️', '🥿', '😂', '🐁', '🦼', '🤎', '🇩🇿', '🈺', '🦘', '🥃', '🍡', '🗻', '🪕', '🤒', '🤤', '💬', '🐎', '🚣', '💊', '🧇', '🇬🇸', '▶️', '📇', '📠', '🆒', '🔲', '🇰🇲', '🇵🇪', '✔️', '🇨🇳', '🧘', '🐦', '🆙', '🇮🇴', '🌈', '🎵']
    }
  },
  components: {
  },
  mounted () {
    this.$store.dispatch('getVideoMatrix')
  },
  methods: {
    copyEmojiCode () {
      navigator.clipboard.writeText(this.toEmoji)
      console.log('Emoji Copied')
      this.snackbar_text = 'Emoji Copied to Clipboard!'
      this.snackbar = true
    },
    copyTextCode () {
      navigator.clipboard.writeText(this.toYt)
      console.log('Text Copied')
      this.snackbar_text = 'Text Copied to Clipboard!'
      this.snackbar = true
    },
    emojiSelf () {
      this.inEmoji = '😻🏯🥙🛐✉️🐲'
      this.snackbar_text = 'Secret Corner Emoji!'
      this.snackbar = true
    }
    // legalEmoji: function () {
    //   const tempTom = []
    //   const emojiList = this.emoji_list
    //   // const emojiListStr = this.emoji_list.join('')
    //   for (let t = 0; t < emojiList.length; t++) {
    //     const regexMatch = emojiList[t].match(emojiStrictRegex())
    //     if (regexMatch < 1) {
    //       console.log(`${emojiList[t]} | ${t}`)
    //     } else {
    //       tempTom.push(emojiList[t])
    //     }
    //   }
    //   console.log(tempTom)
    //   console.log(emojiList)
    //   return tempTom
    // }
  },
  computed: {
    toEmoji: function () {
      if (!this.inText) {
        return ''
      }
      // const emojiLen = this.sm_emoji_list.length
      const ytLen = this.youtube_ascii_list.length
      const emojiList = this.emoji_list
      const emojiLen = emojiList.length
      const ytList = this.youtube_ascii_list

      // console.log('EMOJI_LEN=' + emojiLen.toString())

      function recurEmoji (dec) {
        const oper = dec.divmod(bigInt(emojiLen))
        const x = oper.remainder
        const rest = oper.quotient
        if (Number(rest) === 0) {
          // console.log(emojiList[x])
          // console.log(`| ${x} | ${rest} | ${emojiList[Number(x)]} | ${dec} | ${emojiLen}`)
          return emojiList[Number(x)]
        }
        // console.log(`| ${x} | ${rest} | ${emojiList[Number(x)]} | ${dec} | ${emojiLen}`)
        return recurEmoji(rest) + emojiList[Number(x)]
      }

      let total = bigInt(0)
      for (let i = 0; i < this.inText.length; i++) {
        // console.log(`${i}: ${this.inText[i]} | ${ytList.indexOf(this.inText[i].toString())} | ${(ytList.indexOf(this.inText[i].toString()) * (ytLen ** (i)))} | ${ytLen ** i}`)
        total = total.add((bigInt(ytLen).pow(i)).times(bigInt(ytList.indexOf(this.inText[i].toString()))))
        // console.log(ytList.indexOf(this.inText[i].toString()))
        // console.log(`${i}: ${this.inText[i]} | ${ytList.indexOf(this.inText[i].toString())} | ${(ytList.indexOf(this.inText[i].toString()) * (ytLen ** (i)))} | ${ytLen ** i}`)
        // total = total + (ytList.indexOf(this.inText[i].toString()) * (ytLen ** (i)))
      }
      // console.log(total)
      const result = recurEmoji(total)
      // console.log(result)
      return result
      // return this.inText.split('').reverse().join('')
    },
    toYt: function () {
      if (!this.inEmoji) {
        return ''
      }
      const emojiList = this.emoji_list
      const emojiLen = emojiList.length
      const ytList = this.youtube_ascii_list
      const ytLen = ytList.length

      function recurYt (dec) {
        const oper = dec.divmod(bigInt(ytLen))
        const x = oper.remainder
        const rest = oper.quotient
        // eslint-disable-next-line eqeqeq
        if (Number(rest) == 0) {
          // console.log(`# ${x} | ${rest} | ${ytList[x]} | ${dec} | ${ytLen}`)
          // console.log(`# ${typeof (x)} | ${typeof (rest)} | ${typeof (ytList[x])} | ${typeof (dec)} | ${typeof (ytLen)}`)
          return ytList[Number(x)].toString()
        }
        // console.log(`| ${x} | ${rest} | ${ytList[x]} | ${dec} | ${ytLen}`)
        // console.log(`# ${typeof (x)} | ${typeof (rest)} | ${typeof (ytList[x])} | ${typeof (dec)} | ${typeof (ytLen)}`)
        return recurYt(rest) + ytList[Number(x)].toString()
      }

      let total = bigInt(0)
      const regex = emojiRegex()
      const emojiListStr = emojiList.join('')

      // test stupid shit delete me
      // console.log('-----------')
      // const tempTom = []
      // for (let t = 0; t < emojiList.length; t++) {
      //   // eslint-disable-next-line prefer-const
      //   let regexMatch = emojiList[t].match(emojiStrictRegex())
      //   if (indexOf(emojiListStr, regexMatch[0]) < 0) {
      //     console.log(`${emojiList[t]} | ${indexOf(emojiListStr, regexMatch[0])} | ${t}`)
      //   } else {
      //     tempTom.push(emojiList[t])
      //   }
      // }
      // console.log(tempTom)
      // console.log('-----------')

      console.log(this.inEmoji.match(regex))

      const regexTry = this.inEmoji.match(regex)
      if (!regexTry) {
        return ''
      }
      const regexMatch = regexTry.reverse()

      for (let i = 0; i < regexMatch.length; i++) {
        // console.log(emojiList.indexOf(regexMatch[i]))
        // console.log(indexOf(emojiListStr, regexMatch[i]))
        // console.log(`${i}: ${regexMatch[i]} | ${indexOf(emojiListStr, regexMatch[i])} | ${indexOf(emojiListStr, regexMatch[i]) * (emojiLen ** i)} | ${emojiLen ** i}`)
        total = total.add((bigInt(emojiLen).pow(i)).times(indexOf(emojiListStr, regexMatch[i])))
        // total = total + (indexOf(emojiListStr, regexMatch[i]) * (emojiLen ** i))
        // total = total + (emojiList.indexOf(regexMatch[i]) * (emojiLen ** (i)))
      }

      // console.log(total)
      const result = recurYt(bigInt(total))
      // console.log(result)
      return result.split('').reverse().join('')
    }
  }
}
</script>

<style scoped>
div.v-snack:not(.v-snack--absolute) {
    height: 100%;
}
</style>
